export class AddBeekeeperUserId {
    static readonly type = '[User] AddBeekeeperUserId';

    constructor(public payload: { userId: string; username: string }) {}
}
